import React from "react";
import { Link, useLocation } from "react-router-dom";

const LandingLayout = ({ children }) => {
    const location = useLocation();
    const loginUrl = `/login?redirect=${encodeURIComponent(location.pathname)}`;

    return (
        <div className="min-h-screen flex flex-col bg-white">
            {/* Header público */}
            <header className="bg-white border-b border-gray-200 fixed w-full top-0 z-50">
                <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
                    <Link to="/" className="text-2xl font-bold text-brand-blue no-underline">
                        reformista<span className="text-brand-yellow">.net</span>
                    </Link>
                    <Link
                        to={loginUrl}
                        className="bg-brand-blue text-white px-5 py-2 rounded-lg font-semibold text-sm hover:bg-blue-800 transition-colors"
                    >
                        Acceder a la plataforma
                    </Link>
                </div>
            </header>

            <main className="flex-1 pt-16">
                {children}
            </main>

            {/* Footer público */}
            <footer className="bg-brand-blue text-white py-10">
                <div className="max-w-5xl mx-auto px-6">
                    <div className="flex flex-col sm:flex-row justify-between gap-8">
                        <div>
                            <span className="text-xl font-bold">
                                reformista<span className="text-brand-yellow">.net</span>
                            </span>
                            <p className="text-gray-300 text-sm mt-1">Transformamos oportunidades en valor</p>
                        </div>
                        <div>
                            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-3">Perfiles</h4>
                            <div className="flex flex-col gap-1">
                                <Link to="/landing/inversor" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors">Inversor / Flipper</Link>
                                <Link to="/landing/agente-inmobiliario" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors">Agente Inmobiliario</Link>
                                <Link to="/landing/constructor" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors">Constructor</Link>
                                <Link to="/landing/comprador" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors">Comprador</Link>
                                <Link to="/landing/propietario" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors">Propietario</Link>
                                <Link to="/landing/decorador" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors">Decorador / Interiorista</Link>
                            </div>
                        </div>
                        <div>
                            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-3">Contacto</h4>
                            <a href="mailto:hola@reformista.net" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors block">hola@reformista.net</a>
                            <a href="/aviso-legal" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-yellow text-sm transition-colors block mt-1">Aviso Legal</a>
                        </div>
                    </div>
                    <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400 text-sm">
                        &copy; 2026 Reformista.net &mdash; Granada, España
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LandingLayout;
